import { scaleElementFontSize } from './scaleElementFontSize';

const DEFAULT_FONT_SIZE = 14;
const units = ['px', 'em', 'rem', 'pt'];

export function fontValueAndUnitSetter(
    originalFontSize: string,
    defaultBackUpInPixels: number = DEFAULT_FONT_SIZE,
    sizeOverride?: string
) {
    const unit = units.find(u => originalFontSize.endsWith(u));

    const parsedFontSize = parseFloat(sizeOverride || originalFontSize);

    if (parsedFontSize) {
        return scaleElementFontSize(parsedFontSize) + (unit || 'px');
    }
    return scaleElementFontSize(defaultBackUpInPixels) + 'px';
}

export function fontUnitGetter(originalFontSize: string) {
    const unit = units.find(u => originalFontSize.endsWith(u));
    return unit || 'px';
}
